<template>
  <div class="table__toolbar">
    <!--------------------------------------
    | select box
    ---------------------------------------->
    <label class="form-label form-checkbox-label table__toolbar-checkbox-select">
      <input
        class="table__toolbar-checkbox-select-input"
        type="checkbox"
        name="select-all-questions"
        id="select-all-questions"
        v-model="select"
      />
      <VisibleText>Select All</VisibleText>
    </label>

    <!--------------------------------------
    | delete
    ---------------------------------------->
    <button
      type="button"
      class="table__toolbar-btn"
      :aria-disabled="String(selectedTopicModels.length === 0)"
      @click="onClickDelete"
    >
      <SvgIconDecorative icon="deleteIcon" />
      <VisibleText>Delete</VisibleText>
    </button>

    <!--------------------------------------
    | bulk edit
    ---------------------------------------->
    <div class="table__toolbar-btn--right-align">
      <button class="table__toolbar-btn" @click="toggleIsDownloading" v-show="!isUploading">
        <SvgIconDecorative icon="downloadIcon" />
        <VisibleText>Download</VisibleText>
      </button>

      <button class="table__toolbar-btn" @click="toggleIsUploading" v-show="!isUploading">
        <SvgIconDecorative icon="upload" />
        <VisibleText>Bulk Upload</VisibleText>
      </button>
      <button class="table__toolbar-btn" @click="toggleIsUploading" v-show="isUploading">
        <SvgIconDecorative icon="upload" />
        <VisibleText v-if="!bulk_upload_received">Cancel Upload</VisibleText>
        <VisibleText v-if="bulk_upload_received">Close Upload</VisibleText>
      </button>

      <button
        class="table__toolbar-btn"
        @click="toggleIsEditing"
        v-show="!isEditing && !isUploading"
      >
        <SvgIconDecorative icon="editAlt" />
        <VisibleText>Edit mode</VisibleText>
      </button>
      <button
        class="table__toolbar-btn"
        @click="toggleIsEditing"
        v-show="isEditing && !isUploading"
      >
        <SvgIconDecorative icon="check" />
        <VisibleText>Done</VisibleText>
      </button>
    </div>

    <button class="table__toolbar-btn--secondary" @click="$emit('add-theme')" v-show="!isUploading">
      <VisibleText>Add Theme</VisibleText>
    </button>
  </div>
</template>

<script>
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import ConfirmMixin from '@/utils/mixins/confirmMixin.js';
import customTopicModelService from '@/services/customTopicModelService.js';

export default {
  name: 'CustomTopicModelEditorOptions',
  mixins: [ConfirmMixin],
  components: {
    SvgIconDecorative,
  },
  props: {
    selectedTopicModels: {
      default: () => [],
      type: Array,
    },
    bulk_upload_received: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      CUSTOM_TOPIC_MODEL_SERVICE: new customTopicModelService(this.$pigeonline),
      select: false,
      isEditing: false,
      isUploading: false,
      isDownloading: false,
    };
  },
  methods: {
    onClickDelete() {
      if (this.selectedTopicModels.length === 0) return;
      this.setConfirmText({
        btn: 'delete theme(s)',
        title: 'delete custom theme?',
      });
      this.setConfirmSourceComponent('topicModelEditor');
      this.setConfirmStatus(false);
      this.setConfirmTarget(this.selectedTopicModels);
      this.setConfirmType('delete');
      this.setConfirmIsVisible(true);
    },
    toggleIsEditing() {
      this.isEditing = !this.isEditing;
      // finished editing, refresh list
      if (!this.isEditing) this.$emit('refresh-topic-models');
      this.$emit('toggle-editing');
    },
    toggleIsUploading() {
      this.isUploading = !this.isUploading;
      this.$emit('toggle-uploading');
    },
    toggleIsDownloading() {
      this.isDownloading = !this.isDownloading;
      this.$emit('toggle-downloading');
    },
    async deleteTopicModels() {
      try {
        await Promise.all(
          this.selectedTopicModels.map(async (modelID) =>
            this.CUSTOM_TOPIC_MODEL_SERVICE.delete(modelID),
          ),
        );
        this.$emit('deleted-themes');
      } catch (e) {
        throw Error('CustomTopicModelEditorOptions:deleteTopicModels: ' + e.message);
      }
    },
  },
  watch: {
    confirmStatus: async function (val) {
      if (
        val &&
        this.confirmSourceComponent === 'topicModelEditor' &&
        this.confirmType === 'delete'
      ) {
        await this.deleteTopicModels();
      }
    },
    select: function (val) {
      if (val) this.$emit('select');
      else this.$emit('deselect');
    },
  },
};
</script>
